import Axios from 'axios'
import { autosUrls } from '../urls'
import router from '../../../router'

export default {
  get_all_autos(context) {
    Axios.get(autosUrls.getAllAutos).then(function (response) {
      context.commit('GET_ALL_AUTOS', response.data)
    })
  },

  get_autos(context, publicId) {  // Add this action similar to destinations
    Axios.get(autosUrls.getAutos + publicId).then(function (response) {
      context.commit('GET_AUTOS', response.data)
    })
  },

  get_auto(context, publicId) {
    Axios.get(autosUrls.getAuto + publicId).then(function (response) {
      context.commit('GET_AUTO', response.data)
    })
  },

  post_auto(context, data) {
    Axios.post(autosUrls.postAuto, data).then(function () {
      context.dispatch('get_all_autos')
      return response  // ← Add this
    }).catch(function (error) {
      context.commit('AUTO_ERRORS', error.data)
      throw error
    })
  },

  update_auto(context, data) {
    Axios.patch(autosUrls.editAuto, data).then(function () {
      context.dispatch('get_all_autos')
       return response  // ← Add this
    }).catch(function (error) {
      context.commit('AUTO_ERRORS', error.data)
      throw error
    })
  },

  delete_auto(context, data) {
    return Axios.patch(autosUrls.deleteAuto, data).then(function (response) {
        context.dispatch('get_all_autos')
        return response;  
    }).catch(function(error) {
        throw error;  
    })
},

  restore_auto(context, publicId) {
    Axios.get(autosUrls.restoreAuto + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_AUTOS', response.data)
      router.push({
        name: 'Module.Autos'
      })
    })
  }
}